<nav class="navbar navbar-light navbar-fixed-top bg-*"style="background-color: #D8431A;"> 
    <div class="col">
      <div class="frame">
        <a style = "cursor: pointer;">
          <img src="assets/img/HS-Logo-White.png" alt="Hunter Logo" tabindex="0" height="100%" width="100%">
        </a>
      </div>
    </div>
  </nav>